@if (isImporting$ | async) {
  <cx-spinner class="overlay"> </cx-spinner>
}

@if (!isRestricted) {
  <div class="import-container">
    <p class="import-title">{{ 'productImport.importTitle' | cxTranslate }}</p>
    <p>{{ 'productImport.importText' | cxTranslate }}</p>
    <div class="form-group row import-buttons">
      <div class="col-sm-6">
        <div class="custom-file">
          <input type="file"
            accept=".csv,.txt"
            class="custom-file-input"
            id="customCSVImport"
            onclick="value = null"
            (change)="onFileSelected($event)">
            @if (!fileName) {
              <label class="custom-file-label" for="customCSVImport">
                {{'productImport.noFileSelected' | cxTranslate}}
              </label>
            }
            @if (fileName) {
              <label class="custom-file-label" for="customCSVImport">
                {{fileName}}
              </label>
            }
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <button class="btn btn-secondary btn-block" type="button" (click)="importFile()">
            {{ 'productImport.buttons.import' | cxTranslate }}
          </button>
        </div>
      </div>
      <hr>
      </div>
    }
